import VCOrganizationInfo from './VCOrganizationInfo';

export default VCOrganizationInfo;
